"use client";

import * as React from "react";
import { cn } from "../../lib/utils";
import ArthaLink20x17Icon from "../icons/ArthaLink20x17Icon";

export interface ProfileAvatarProps {
  src?: string | null;
  alt: string;
  className?: string;
  imageClassName?: string;
  fallbackClassName?: string;
  logoClassName?: string;
}

export function ProfileAvatar({
  src,
  alt,
  className,
  imageClassName,
  fallbackClassName,
  logoClassName,
}: ProfileAvatarProps) {
  const [imageFailed, setImageFailed] = React.useState(false);

  React.useEffect(() => {
    setImageFailed(false);
  }, [src]);

  const showImage = Boolean(src) && !imageFailed;

  return (
    <div
      className={cn(
        "overflow-hidden bg-white flex items-center justify-center",
        className,
      )}
    >
      {showImage ? (
        <img
          src={src ?? undefined}
          alt={alt}
          className={cn("h-full w-full object-cover", imageClassName)}
          onError={() => setImageFailed(true)}
        />
      ) : (
        <div
          role="img"
          aria-label={alt}
          data-testid="profile-avatar-fallback"
          className={cn(
            "flex h-full w-full items-center justify-center bg-[#FFF8F3]",
            fallbackClassName,
          )}
        >
          <ArthaLink20x17Icon
            aria-hidden="true"
            className={cn("h-[48%] w-[48%]", logoClassName)}
          />
        </div>
      )}
    </div>
  );
}
